<ng-container #component></ng-container>